module.exports = __webpack_public_path__ + "img/logo-eduac.48bdbf6c.png";